import { useRef } from 'react';
import { Printer } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { DOC_RULE_SECTIONS } from './docRules';

const RuleTable = ({ rows, idx }) => (
  <table className="my-2 w-full border-collapse text-sm" data-testid={`doc-rules-table-${idx}`}>
    <thead><tr>{rows[0].map(h => <th key={h} className="border border-slate-300 bg-slate-100 p-2 text-left font-semibold">{h}</th>)}</tr></thead>
    <tbody>{rows.slice(1).map(r => <tr key={r[0]}>{r.map((c, i) => <td key={i} className="border border-slate-300 p-2 align-top">{c}</td>)}</tr>)}</tbody>
  </table>
);

const PRINT_CSS = 'body{font-family:Arial,sans-serif;padding:24px;color:#0f172a}h1{font-size:20px}h3{font-size:15px;margin:18px 0 6px}table{border-collapse:collapse;width:100%;font-size:12px}th,td{border:1px solid #cbd5e1;padding:6px;text-align:left;vertical-align:top}th{background:#f1f5f9}li,p{font-size:12px;line-height:1.5}';

export const DocRulesDialog = ({ open, onOpenChange }) => {
  const ref = useRef(null);
  const print = () => {
    const w = window.open('', '_blank');
    if (!w) return;
    w.document.write(`<html><head><title>Talep Belge Kuralları ve Şartları</title><style>${PRINT_CSS}</style></head><body><h1>Talep Belge Kuralları ve Şartları</h1>${ref.current.innerHTML}</body></html>`);
    w.document.close();
    w.focus();
    setTimeout(() => w.print(), 300);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-3xl overflow-y-auto" data-testid="doc-rules-dialog">
        <DialogHeader>
          <DialogTitle>Talep Belge Kuralları ve Şartları</DialogTitle>
          <DialogDescription>Firma evrakları, personel evrakları ve aralarındaki bağlantılar</DialogDescription>
        </DialogHeader>
        <div className="flex justify-end">
          <Button size="sm" variant="outline" onClick={print} data-testid="doc-rules-print-btn"><Printer className="mr-2 h-4 w-4" />PDF olarak indir / Yazdır</Button>
        </div>
        <div ref={ref} className="space-y-4 text-slate-800" data-testid="doc-rules-content">
          {DOC_RULE_SECTIONS.map((s, i) => (
            <section key={s.title} data-testid={`doc-rules-section-${i}`}>
              <h3 className="mb-1 font-semibold text-slate-900">{s.title}</h3>
              {s.intro && <p className="mb-2 rounded border border-amber-300 bg-amber-50 p-2 text-sm text-amber-900">{s.intro}</p>}
              {s.table && <RuleTable rows={s.table} idx={i} />}
              <ul className="list-disc space-y-1 pl-5 text-sm">{s.items.map(t => <li key={t}>{t}</li>)}</ul>
            </section>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
